/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import {
  asideMenuFlag,
  reviewscreenFlag,
  commonConstants,
  sideBarCostants,
  winscpOtpFlags,
  encrypt,
  decrypt,
} from '../constants';

import { projectService } from '../services';

export const commonActions = {
  asideMenu,
  isReviewScreenOpen,
  isDashboard,
  isRiskAnalysisTab,
  showLoader,
  hideLoader,
  toggleSidebar,
  toggleWinscpOtp,
  getGlobalMapping,
  getGlobalMapping_enc,
};

function getGlobalMapping(options, callback) {
  return (dispatch) => {
    dispatch(showLoader());
    projectService
      .getGlobalMapping(options)
      .then((res) => {
        dispatch(hideLoader());
        callback(null, res);
      })
      .catch((err) => {
        dispatch(hideLoader());
        callback(err, null);
      });
  };
}

function getGlobalMapping_enc(options, callback) {
  return (dispatch) => {
    const encryptOptions = encrypt(options);
    dispatch(showLoader());
    projectService
      .getGlobalMapping_enc(options)
      .then((response) => {
        let res = JSON.parse(decrypt(response.r));
        let mapping = res;
        dispatch(hideLoader());
        callback(null, mapping);
      })
      .catch((err) => {
        dispatch(hideLoader());
        callback(err, null);
      });
  };
}

function toggleWinscpOtp(data) {
  if (data) {
    return { type: winscpOtpFlags.DISPLAY_WINSCP_OTP };
  } else {
    return { type: winscpOtpFlags.HIDE_WINSCP_OTP };
  }
}

function asideMenu(data) {
  if (data) {
    return { type: asideMenuFlag.ASIDE_MENU_OPEN };
  } else {
    return { type: asideMenuFlag.ASIDE_MENU_CLOSE };
  }
}

function isReviewScreenOpen(data) {
  if (data) {
    return { type: reviewscreenFlag.REVIEW_SCREEN_OPEN };
  } else {
    return { type: reviewscreenFlag.REVIEW_SCREEN_CLOSE };
  }
}

function isDashboard(data) {
  if (data) {
    return { type: commonConstants.IS_DASHBOARD_ON };
  } else {
    return { type: commonConstants.IS_DASHBOARD_OFF };
  }
}

function isRiskAnalysisTab(data) {
  if (data) {
    return { type: commonConstants.IS_RISK_ANALYSIS_TAB_ACTIVE };
  } else {
    return { type: commonConstants.IS_RISK_ANALYSIS_TAB_INACTIVE };
  }
}

function showLoader() {
  return { type: commonConstants.SHOW_LOADER };
}

function hideLoader() {
  return { type: commonConstants.HIDE_LOADER };
}
//fuction to toggle sidebar
function toggleSidebar(sidebarState) {
  return { type: sideBarCostants.SHOW_SIDEBAR, payload: sidebarState };
}
